import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { BiData } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../../types/deviation';
import DesktopShareModal from '../../../SharePopup/DesktopSharePopup/DesktopShareModal';
const ShareOnSocial = ({ deviation  })=>{
    const [isShareModalShown, setIsShareModalShown] = useState(false);
    const showShareModal = ()=>setIsShareModalShown(true);
    const hideShareModal = ()=>setIsShareModalShown(false);
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ListItem, {
        label: t('common.share'),
        onClick: showShareModal,
        biData: BiData({
            evid: 355,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            deviationid: deviation.deviationId
        })
    }), isShareModalShown && /*#__PURE__*/ React.createElement(DesktopShareModal, {
        deviation: deviation,
        onRequestClose: hideShareModal
    }));
};
ShareOnSocial.displayName = 'ShareOnSocial';
export default ShareOnSocial;
